import { useState, useEffect } from 'react';

const CACHE_KEY = 'ltr_station_count';
const CACHE_TIMESTAMP_KEY = 'ltr_station_count_timestamp';
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export function useStationCount() {
  const [count, setCount] = useState<number>(() => {
    // Try to get cached value on initial load
    const cached = localStorage.getItem(CACHE_KEY);
    return cached ? parseInt(cached, 10) : 7; // Default to 4
  });

  useEffect(() => {
    const fetchStationCount = async () => {
      try {
        // Check if we have a recent cached value
        const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);
        const now = Date.now();
        
        if (cachedTimestamp && now - parseInt(cachedTimestamp, 10) < CACHE_DURATION) {
          // Cache is still valid, don't fetch
          return;
        }

        // Fetch fresh data
        const response = await fetch('https://on.ltr.ovh/stations');
        const data = await response.json();

        // Parse the API response: { station_count: 7, stations: {...} }
        const stationCount = data.station_count || Object.keys(data.stations || {}).length || 4;
        
        // Update state and cache
        setCount(stationCount);
        localStorage.setItem(CACHE_KEY, stationCount.toString());
        localStorage.setItem(CACHE_TIMESTAMP_KEY, now.toString());
      } catch (error) {
        console.error('Failed to fetch station count:', error);
        // Keep using cached value or default
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          setCount(parseInt(cached, 10));
        }
      }
    };

    fetchStationCount();
    
    // Refresh every 5 minutes
    const interval = setInterval(fetchStationCount, CACHE_DURATION);
    
    return () => clearInterval(interval);
  }, []);

  return count;
}

